"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5624],{

/***/ 81056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Linker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* provided dependency */ var process = __webpack_require__(83454);
var ref, ref1;



var IS_PROD = (process === null || process === void 0 ? void 0 : (ref = process.env) === null || ref === void 0 ? void 0 : "false") === "false" && (process === null || process === void 0 ? void 0 : (ref1 = process.env) === null || ref1 === void 0 ? void 0 : "G-MF0S173L5Y") ? true : false;
function Linker(param) {
    var url = param.url, classes = param.classes, title = param.title, ariaLabel = param.ariaLabel, children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // console.log(router.asPath)
    // console.log(router.pathname, url)
    // check if URL starts with tel:
    // create a function to return this: return gtag_report_conversion(${url});
    // then pass it to onClick
    var handleClick = function(url) {
        if (IS_PROD) {
            return gtag_report_conversion("".concat(url));
        } else {
            return;
        }
    };
    if (!url) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
            children: children
        });
    } else if (url.startsWith("tel:")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
            onClick: function() {
                return handleClick(url);
            },
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: classes ? classes : "",
            title: "call",
            "aria-label": "call",
            children: children
        });
    } else if (url.includes("https") || url.includes("http")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: classes ? classes : "",
            children: children
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: url,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                className: "".concat(classes ? classes : "", " ").concat(router.asPath === url ? "active" : ""),
                title: title,
                "aria-label": ariaLabel,
                children: children
            })
        });
    }
}
function gtag_report_conversion(arg0) {
    throw new Error("Function not implemented.");
}


/***/ }),

/***/ 28038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./components/layout/footer/social-links.js
var social_links = __webpack_require__(36050);
// EXTERNAL MODULE: ./components/content/linker/index.tsx
var linker = __webpack_require__(81056);
;// CONCATENATED MODULE: ./components/layout/footer/bottom-footer-nav.js


function BottomFooterNav(param) {
    var bottomFooterNav = param.bottomFooterNav;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
        className: "flex sm:ml-4",
        children: bottomFooterNav === null || bottomFooterNav === void 0 ? void 0 : bottomFooterNav.map(function(link) {
            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                    url: link.siteLink,
                    classes: "mr-2 text-xs text-gray-200 md:text-sm hover:underline",
                    children: link.title
                })
            }, link._key);
        })
    });
}

// EXTERNAL MODULE: ./utils/helpers.ts
var helpers = __webpack_require__(949);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var index_esm = __webpack_require__(53854);
;// CONCATENATED MODULE: ./components/layout/footer/index.js







var SubLinks = function(param) {
    var subLinks = param.subLinks;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                className: "text-sm font-semibold tracking-tight text-gray-200 uppercase",
                children: subLinks === null || subLinks === void 0 ? void 0 : subLinks.title
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                className: "mt-4",
                children: subLinks === null || subLinks === void 0 ? void 0 : (ref = subLinks.links) === null || ref === void 0 ? void 0 : ref.map(function(link) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                        className: "mb-2 text-base text-gray-100",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                            url: link.siteLink,
                            classes: "hover:underline",
                            children: link.title
                        })
                    }, link._key);
                })
            })
        ]
    });
};
function Footer(param) {
    var topFooterNav = param.topFooterNav, bottomFooterNav = param.bottomFooterNav, siteSettings = param.siteSettings;
    var ref, ref1;
    var socialLinks = siteSettings.socialLinks, organizationDetails = siteSettings.organizationDetails;
    var gridCount = [];
    var hasContact = (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.address) || (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.phoneNumber) ? true : false;
    var hasHours = (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.operationHours) && (organizationDetails === null || organizationDetails === void 0 ? void 0 : (ref = organizationDetails.operationHours) === null || ref === void 0 ? void 0 : ref.length) >= 1 ? true : false;
    var hasSubLinks = topFooterNav === null || topFooterNav === void 0 ? void 0 : topFooterNav.some(function(vendor) {
        var ref;
        return ((ref = vendor["links"]) === null || ref === void 0 ? void 0 : ref.length) >= 1;
    });
    var subLinkArray = (topFooterNav === null || topFooterNav === void 0 ? void 0 : topFooterNav.map(function(vendor) {
        var ref;
        return ((ref = vendor["links"]) === null || ref === void 0 ? void 0 : ref.length) >= 1;
    }).filter(function(val) {
        return val === true;
    })) || [];
    gridCount = [
        hasContact,
        hasHours
    ].concat((0,_to_consumable_array/* default */.Z)(subLinkArray));
    gridCount = gridCount.filter(function(value) {
        return value;
    }).length;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("footer", {
        className: "text-gray-100 bg-brand-2-700 body-font",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "py-10 mx-auto inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "grid gap-6 md:grid-cols-".concat(gridCount >= 3 ? 2 : 1, " md:gap-10 lg:gap-8 lg:grid-cols-").concat(gridCount),
                    children: [
                        hasContact && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                    className: "text-sm font-semibold tracking-tight text-gray-200 uppercase",
                                    children: "Contact"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "mt-4",
                                    children: [
                                        (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.address) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "mb-2 text-base text-gray-100",
                                            children: organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.address
                                        }),
                                        ((organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.city) || (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.state) || (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.zip)) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "mb-2 text-base text-gray-100",
                                            children: [
                                                organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.city,
                                                " ",
                                                organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.state,
                                                " ",
                                                organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.zip
                                            ]
                                        }),
                                        (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.directionsMapURL) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "flex items-center mb-2 space-x-2 text-base text-gray-100",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiLocationMarker */.XAC, {}),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.directionsMapURL,
                                                    classes: "hover:underline",
                                                    children: "Map and Directions"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "flex items-center mb-2 space-x-2 text-base text-gray-100",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* HiMail */.hBs, {}),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "/contact",
                                                    classes: "hover:underline",
                                                    children: "Email Us"
                                                })
                                            ]
                                        }),
                                        (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.phoneNumber) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "mb-2 text-base text-gray-100",
                                            children: [
                                                "T: ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "tel:".concat(organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.phoneNumber),
                                                    classes: "hover:underline",
                                                    children: organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.phoneNumber
                                                })
                                            ]
                                        }),
                                        (organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.faxNumber) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "mb-2 text-base text-gray-100",
                                            children: [
                                                "F: ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "tel:".concat(organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.faxNumber),
                                                    classes: "hover:underline",
                                                    children: organizationDetails === null || organizationDetails === void 0 ? void 0 : organizationDetails.faxNumber
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        hasHours && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                    className: "text-sm font-semibold tracking-tight text-gray-200 uppercase",
                                    children: "Hours"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                                    className: "table w-full mt-4",
                                    children: organizationDetails === null || organizationDetails === void 0 ? void 0 : (ref1 = organizationDetails.operationHours) === null || ref1 === void 0 ? void 0 : ref1.map(function(time) {
                                        /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("li", {
                                            className: "table-row text-base text-gray-100",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                    className: "table-cell pb-1",
                                                    children: time.day
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                    className: "table-cell pb-1",
                                                    children: [
                                                        (0,helpers/* toggle24hr */.q0)(time === null || time === void 0 ? void 0 : time.opensAt, 0),
                                                        " - ",
                                                        (0,helpers/* toggle24hr */.q0)(time === null || time === void 0 ? void 0 : time.closesAt, 0)
                                                    ]
                                                })
                                            ]
                                        }, time._key);
                                    })
                                })
                            ]
                        }),
                        hasSubLinks && (topFooterNav === null || topFooterNav === void 0 ? void 0 : topFooterNav.map(function(subLinks) {
                            return (subLinks === null || subLinks === void 0 ? void 0 : subLinks.links) && subLinks.links.length >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SubLinks, {
                                subLinks: subLinks
                            }, subLinks._key);
                        }))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "bg-brand-2-800",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "flex flex-col items-center px-5 py-6 mx-auto inner-wrapper sm:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                            className: "mt-4 ml-4 text-xs text-gray-200 md:text-sm sm:mt-0",
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " ",
                                siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.title,
                                " - All Rights Reserved."
                            ]
                        }),
                        bottomFooterNav && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BottomFooterNav, {
                            bottomFooterNav: bottomFooterNav
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "grid justify-center grid-flow-col gap-2 auto-cols-max sm:ml-auto sm:mt-0",
                            children: socialLinks && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(social_links/* SocialLinks */.W, {
                                socialLinks: socialLinks
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 36050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SocialLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(949);
/* harmony import */ var _react_icons_all_files_fa_FaFacebookF__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62916);
/* harmony import */ var _react_icons_all_files_fa_FaTwitter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31362);
/* harmony import */ var _react_icons_all_files_fa_FaInstagram__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80681);
/* harmony import */ var _react_icons_all_files_fa_FaLinkedinIn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57951);
/* harmony import */ var _react_icons_all_files_fa_FaYoutube__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18320);
/* harmony import */ var _react_icons_all_files_fa_FaVimeoV__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94891);
/* harmony import */ var _react_icons_all_files_fa_FaPinterestP__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56625);
/* harmony import */ var _react_icons_all_files_fa_FaRedditAlien__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27443);
/* harmony import */ var _react_icons_all_files_fa_FaMediumM__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89061);
/* harmony import */ var _react_icons_all_files_fa_FaTwitch__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90105);
/* harmony import */ var _react_icons_all_files_fa_FaDiscord__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82365);













function SocialIcon(socialType) {
    switch(socialType){
        case "facebook":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaFacebookF__WEBPACK_IMPORTED_MODULE_2__/* .FaFacebookF */ .t, {});
            break;
        case "twitter":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaTwitter__WEBPACK_IMPORTED_MODULE_3__/* .FaTwitter */ .f, {});
            break;
        case "instagram":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaInstagram__WEBPACK_IMPORTED_MODULE_4__/* .FaInstagram */ .Z, {});
            break;
        case "linkedin":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaLinkedinIn__WEBPACK_IMPORTED_MODULE_5__/* .FaLinkedinIn */ .B, {});
            break;
        case "youtube":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaYoutube__WEBPACK_IMPORTED_MODULE_6__/* .FaYoutube */ .V, {});
            break;
        case "vimeo":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaVimeoV__WEBPACK_IMPORTED_MODULE_7__/* .FaVimeoV */ .H, {});
            break;
        case "tiktok":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 448 512",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                    d: "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                })
            });
            break;
        case "pinterest":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaPinterestP__WEBPACK_IMPORTED_MODULE_8__/* .FaPinterestP */ .c, {});
            break;
        case "reddit":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaRedditAlien__WEBPACK_IMPORTED_MODULE_9__/* .FaRedditAlien */ .V, {});
            break;
        case "medium":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaMediumM__WEBPACK_IMPORTED_MODULE_10__/* .FaMediumM */ .C, {});
            break;
        case "twitch":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaTwitch__WEBPACK_IMPORTED_MODULE_11__/* .FaTwitch */ .a, {});
            break;
        case "discord":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_react_icons_all_files_fa_FaDiscord__WEBPACK_IMPORTED_MODULE_12__/* .FaDiscord */ .j, {});
            break;
        default:
            return null;
    }
}
function SocialLinks(param) {
    var socialLinks = param.socialLinks;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: socialLinks.map(function(socialLink) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                href: socialLink.siteLink,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "px-1 py-3 text-2xl text-gray-300 transition-all hover:text-success",
                "aria-label": "Link to ".concat((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__/* .capitalizeFirstLetter */ .fm)(socialLink.socialType)),
                children: SocialIcon(socialLink.socialType)
            }, socialLink._key);
        })
    });
}


/***/ }),

/***/ 87821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/layout/logo/index.tsx


Logo.propTypes = {
    classes: (prop_types_default()).string,
    alt: (prop_types_default()).string,
    mode: (prop_types_default()).string || "light"
};
function Logo(props) {
    var classes = props.classes, alt = props.alt, mode = props.mode;
    var logoColor = mode === "dark" ? "#fff" : "#111";
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 477.2 260.3",
        className: classes,
        children: [
            alt && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("clipPath", {
                        id: "clippath",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                            d: "m137.4 260.2-144.3.1L-7.1 0h114.5L106 31l-.2 113.8 31.5 8.6z",
                            fill: "none"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("style", {
                        children: ".st2{fill:#2a2e2f}.st5{fill:#fff}.st6{fill:#852e2c}"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                className: "st6",
                d: "M112.6 103.1V43.9h19.7c6.2 0 11 .4 15 3.2 5.2 3.7 8 9.2 8 16.6s-5 16.7-13.4 19.1l14.5 20.3h-17.9L127.2 84v19.1h-14.5Zm17.3-32c7.2 0 10.7-1.8 10.7-7.2s-3.1-6.9-9.5-6.9h-4v14.1zM161 103V52.9h27.2V64h-14.9v8.1h14.9v11.1h-14.9v8.7h14.9V103zM195 103V52.9h17.1c8 0 13.5 1.1 18.7 6 4.8 4.5 7.3 11.1 7.3 19.3s-2.5 13.9-7.3 18.6c-5.4 5.2-10.1 6.2-17.1 6.2h-18.8Zm30.9-25.2c0-9-4.9-14.1-13.9-14.1h-4.9V92h4.9c9.4 0 13.8-4.4 13.8-14.2ZM264.4 103.1l-16-59.2h15.7l7.9 33.9 8.5-33.9h12.8l8.4 33.9 8-33.9h15.6l-16 59.2H296L286.9 70l-9.2 33.1zM331.4 59.3c4.9-4.9 11.1-7.3 18.2-7.3s13 2.6 17.9 7.4c5.1 5 7.7 11.4 7.7 18.2s-2.5 13.6-7.3 18.5c-4.9 5.1-11.5 7.8-18.5 7.8s-13.7-2.7-18.7-7.9c-4.7-5-7.1-11.2-7.1-18.6s2.7-13.2 7.6-18.1Zm18.2 32.2c7.2 0 13-5.8 13-13.9s-5.8-13.2-12.9-13.2-13.3 5.8-13.3 13.2 6.3 13.9 13.2 13.9M381 103V52.9h12.2v39h14.3V103zM413.2 52.9h27.2V64h-14.9v8h14.9v11.3h-14.9V103h-12.3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                className: "st2",
                d: "M112.4 153.1v-43.8H127c4.6 0 8.1.3 11.1 2.4 3.9 2.7 5.9 6.8 5.9 12.3s-3.7 12.4-9.9 14.1l10.7 15h-13.3l-8.4-14.1v14.1zm12.8-23.6c5.3 0 7.9-1.4 7.9-5.3s-2.3-5.1-7-5.1h-3v10.4zM150.1 153.1v-43.8h23.8v9.7h-13.1v7.1h13.1v9.7h-13.1v7.6h13.1v9.7zM182.4 153.1v-43.8h10.7v34.2h12.5v9.7h-23.2ZM211.8 153.1v-43.8h10.7v43.8zM238.9 153.1h-11.7l16.8-43.8h8.8l16.8 43.8h-11.8l-2.2-6.4h-14.5zm9.5-29.5-4.4 14.1h8.7zM273.5 109.2h15c8.9 0 13.6 3.9 13.6 10.8s-1.7 7.5-5.5 9.4c5.1 1.5 7.5 4.8 7.5 10.1s-1.5 7.8-4.3 10.3c-3.2 2.9-7.2 3.3-13 3.3h-13.3v-43.8Zm13 17.1c4 0 5.9-.9 5.9-3.7s-1.6-4.1-4.9-4.1H284v7.8h2.6Zm1 17.6c4.1 0 6-1 6-4.6s-1.9-4.7-6.2-4.7h-3.5v9.2h3.6ZM310 153.1v-43.8h10.7v43.8zM329.5 153.1v-43.8h10.7v34.2h12.5v9.7h-23.2ZM359.6 153.1v-43.8h10.7v43.8zM383.4 153.1v-33.7h-8.1v-10.2h27.2v10.2h-8.3v33.7h-10.7ZM417.5 153.1v-16.2L405 109.3h11.8l6.4 16.1 6.7-16.1h11.2l-12.8 27.6v16.2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("g", {
                clipPath: "url(#clippath)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        className: "st2",
                        d: "M122.7 76.7c9.2 0 17.4-.5 22 5-7.4-1.3-14.5 1.4-14.5 1.4s27.4 1.8 31 20.5c-1.5-.8-5.5-2.3-9.2-3.1s-9.3-.9-9.2-1c1.7-2.2 5.2-5.6 5.2-5.6s-8.5 1-12.6 5c.6-2.2 1.9-5.5 3.4-7.2-12.5 5.2-13.6 14.6-16.6 23-5.8 14.7-16.5 7.5-16.5 17.3v3.4l-.2 22.5c1.4.4 2.9 1.6 4.1 3.3-6.8-1.8-12.7 1.8-15 6.8 6.1-3.1 14.3-3.6 17.4 2.4-6.8-3.8-16.1-1.4-19.8 7.1 7.1-3.8 17.2-4.7 24.2-.3 7.3 4.6 4.9 8.8 1.9 12-7.2 7.7 6 11.7 14.4 4.8 2 9.4-8.5 11.4-15.6 10.6-4.1-.5-8.6-1.2-14.2.8 4.3 1.1 10.9 1.6 15.2 1.3-4.6 6.4-20.5 6.3-25.6-1.8-15.9.3-18.1-24.1-12.5-33.9 1 5.5 3.2 9.2 5.7 10.4-1.9-13.6 6.3-29.5 4.9-42.7-4 7.9-8.7 13.4-14.9 19.8 1.2-4.6 2.1-8.7 2.3-13.8-2 3.8-5.9 6.9-5.9 6.9s.5-5.8.7-9c-8.8-.1-19.1-.6-30.1-17.5.6 20.5 17.9 29.4 21.6 33.6-5 .3-13-2.2-18.5-5.6C49 161 57.7 164.3 65 167c12.5 12.4 0 34.8 25.4 42.2-3.7 15.6 12.9 21.9 11 41.4-20.9-29-47.4-34.6-60.7-77.4-1.4 18.5 5.8 35.4 18.8 53.2-20.2-15.7-38.1-33-38.4-73.9-3.5 5.1-5.9 8.8-8.1 13.8-3-16.3-1.1-32.6 6-47.5l-8.1 1c3.4-17.2 11.1-32.5 19.9-44.6-6.2-6-9.5-15.2-8.6-24.4 2 3.4 4.3 6 5.9 7.4-5.6-13.6 4.8-39.4 20.1-48.1.1 10.3 23.7 28.6 34.3 37.6 7-2.6 15.2-4 23.9-4s16.9 1.7 23.8 4.4c10.8-8.8 34.7-26.7 35-37 15.1 9 25 35 19.2 48.5 1.7-1.4 4-4 6.1-7.3.8 9.3-7.3 17.4-14.4 20.8 4.2-15.1 4.4-30.9-4.4-44.4-9.2 15.2-16.2 26.7-28.2 36.5 4 6.7 14.8 14.4 24.5 18.5-3.9-3.3-7.9-10.1-10.2-14.7 6.2-7.6 9.5-13.6 13.5-26 3.1 8.9 3.2 20.6-2.3 30.5 4 7 2 14.4-4.2 28.2 0 0-3.2-34.1-42.2-24.9Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        className: "st6",
                        d: "M53 70.7c-5.6 2.9-10.3 2.8-10.3 2.8s6.3-6.3 8.9-11.9c-3.9-5.8-6.5-11.6-9.4-21.5-3.4 4.9-5.4 19.7-5 25.6-5.5-12.5-2.7-28.5 4.9-39.5 8.9 15.4 15.7 27 27.5 37-4.2 6.6-15.1 14.1-24.8 18 2.9-2.4 5.9-6.6 8.2-10.5M90.7 122.6c-4.3 5.8-10.2 9.7-17.6 10 1.2-1.5 2.4-3.5 3.1-5.3-5.5 2.5-13.8 2.2-17.1.6 0 0 4.3-2.4 7.5-4.4-6.9-.2-11.8-6.8-13.1-13 12.9 14.5 21.4 4.8 29.9 10.7-3.2-14.2-9.6-17.4-23.6-15.8 1 1.1 1.9 2.7 2.4 4-3.6-2-5.5-3.1-11.3-5.7 5.6-2.2 12-4.2 18.1-4.1-1.5-1.7-3.3-3.8-5.2-5.6 0 0 8.2.9 12.6 5-.5-2.2-2-5.5-3.4-7.2 18.8 7.9 10.1 21.8 23.6 32-2 0-3.6 0-5.8-1.1Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        className: "st2",
                        d: "M56 112.7c9.8 10.1 21 3.6 27.6 8.4-2.5-13.3-9.8-17.1-23.6-15.7 1 .7 2.1 2.8 2.4 4-4.1 0-7.4-1.2-10.4-3.1 0 0 2.1 4.5 4.1 6.4Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        className: "st5",
                        d: "M76.7 110.9c0 1.9-1.5 3.5-3.4 3.5s-3.4-1.5-3.5-3.4 0-1 .3-1.4c-.8.8-1.3 2-1.3 3.2 0 2.5 2.1 4.4 4.5 4.4 2.5 0 4.4-2.1 4.4-4.5s-.5-2.2-1.3-3c.2.4.2.8.3 1.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        className: "st2",
                        d: "M156 112.7c-9.8 10.1-21 3.6-27.6 8.4 2.5-13.3 9.7-17.1 23.6-15.7-1 .7-2.1 2.8-2.4 4 4.1 0 7.4-1.2 10.4-3.1 0 0-2.1 4.5-4.1 6.4Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                        className: "st5",
                        d: "M135.3 110.9c0 1.9 1.5 3.5 3.4 3.5s3.4-1.5 3.5-3.4 0-1-.3-1.4c.8.8 1.3 2 1.3 3.2 0 2.5-2.1 4.4-4.5 4.4-2.5 0-4.4-2.1-4.4-4.5s.5-2.2 1.3-3c-.2.4-.2.8-.3 1.2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                className: "st6",
                d: "M453.6 49.7c-.7.7-1.6 1.1-2.6 1.1s-1.9-.4-2.6-1.1-1-1.6-1-2.6.3-1.9 1-2.6 1.6-1.1 2.6-1.1 1.9.4 2.6 1.1 1 1.6 1 2.6-.3 1.9-1 2.6m-4.8-.3c.6.6 1.3.9 2.2.9s1.6-.3 2.2-.9.9-1.4.9-2.3-.3-1.7-.9-2.3-1.3-.9-2.2-.9-1.6.3-2.2.9-.9 1.4-.9 2.3.3 1.7.9 2.3m.8-.4v-4h1.8q.6 0 .9.3c.3.3.3.5.3.8 0 .5-.2.8-.7 1q.6.15.6.9c0 .6.1 1 .2 1h-.6s-.1-.3-.2-.9c0-.5-.3-.8-.8-.8h-.9V49zm.6-3.5v1.3h1.1c.5 0 .7-.2.7-.6s-.2-.7-.7-.7z"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("text", {
                style: {
                    fontFamily: "MyriadPro-Regular,'Myriad Pro'",
                    fontSize: 12
                },
                transform: "translate(124.6 -57.5)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tspan", {
                        x: "0",
                        y: "0",
                        children: "Pantone 426 C"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tspan", {
                        x: "0",
                        y: "14.4",
                        children: "Pantone 762"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("text", {
                style: {
                    fontFamily: "ITCAvantGardePro-Bk,'ITC Avant Garde Gothic Pro'",
                    fontSize: 24,
                    letterSpacing: 0
                },
                transform: "translate(339.9 176.8)",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tspan", {
                    x: "0",
                    y: "0",
                    children: "Est. 2000"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("text", {
                style: {
                    fontSize: 14,
                    letterSpacing: 0,
                    fontFamily: "ITCAvantGardePro-Bk,'ITC Avant Garde Gothic Pro'"
                },
                transform: "translate(648.2 170.6)",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("tspan", {
                    x: "0",
                    y: "0",
                    children: "Est. 2000"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/content/linker/index.tsx
var linker = __webpack_require__(81056);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
;// CONCATENATED MODULE: ./components/layout/header/drop-down.js



function DropDown(param) {
    var link = param.link;
    var useOutsideAlerter = function useOutsideAlerter(ref) {
        (0,compat_module.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setLinkState(false);
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var ref = (0,compat_module.useState)(false), linkState = ref[0], setLinkState = ref[1];
    var wrapperRef = (0,compat_module.useRef)(null);
    useOutsideAlerter(wrapperRef);
    var handleClick = function() {
        setLinkState(function(linkState) {
            return !linkState;
        });
    // console.log(`linkState ${linkState === true ? 'true' : 'false'}`)
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "relative",
            ref: wrapperRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("button", {
                    onClick: function() {
                        return handleClick();
                    },
                    type: "button",
                    "aria-expanded": linkState,
                    className: "inline-flex items-center text-base font-medium text-gray-500 bg-white rounded-md group hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            children: link.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            "aria-hidden": "true",
                            className: "w-5 h-5 ml-2 text-gray-500 group-hover:text-gray-500",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                fillRule: "evenodd",
                                d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                                clipRule: "evenodd"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "".concat(linkState === true ? "transform opacity-100 scale-100 visible absolute right-0 z-10 mt-2 origin-top-right rounded-md shadow-lg whitespace-nowrap min-w-[200px]" : "transform opacity-0 scale-95 invisible absolute right-0 z-10 mt-2 origin-top-right rounded-md shadow-lg whitespace-nowrap", " "),
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "px-2 py-2 text-right bg-white rounded-md shadow",
                        children: link.links.map(function(subLink) {
                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                classes: "text-gray-600 block px-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none focus:shadow-outline transition-all",
                                url: subLink.siteLink,
                                children: subLink.title
                            }, subLink._key);
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/useUser.tsx
var useUser = __webpack_require__(83996);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/layout/header/mobile-nav.js
/* provided dependency */ var process = __webpack_require__(83454);







var DynamicComponentWithNoSSR = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7265).then(__webpack_require__.bind(__webpack_require__, 27265));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27265)
            ];
        }
    },
    ssr: false
});
function MobileNav(param) {
    var siteNav = param.siteNav, topNav = param.topNav, appLoginEnabled = param.appLoginEnabled;
    var useOutsideAlerter = function useOutsideAlerter(ref) {
        (0,compat_module.useEffect)(function() {
            /**
       * Alert if clicked on outside of element
       */ function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setLinkState(false);
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return function() {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var ref, ref1, ref2;
    var ref3 = (0,compat_module.useState)(false), linkState = ref3[0], setLinkState = ref3[1];
    var wrapperRef = (0,compat_module.useRef)(null);
    var Router = (0,router.useRouter)();
    var ref4 = (0,useUser/* useUser */.aF)(), isLoading = ref4.isLoading, subscription = ref4.subscription, userDetails = ref4.userDetails;
    useOutsideAlerter(wrapperRef);
    var handleClick = function() {
        setLinkState(function(linkState) {
            return !linkState;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "-my-2 lg:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("button", {
                    type: "button",
                    "aria-expanded": linkState,
                    onClick: function() {
                        return handleClick();
                    },
                    className: "inline-flex items-center justify-center p-2.5 bg-white border border-white rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "sr-only",
                            children: "Open menu"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "aria-hidden": "true",
                            className: "w-6 h-6 text-gray-500",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "2",
                                d: "M4 6h16M4 12h16M4 18h16"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("nav", {
                className: "".concat(linkState === true ? "visible transform opacity-100 flex-col flex w-full mt-6 lg:hidden" : "transform opacity-0 hidden lg:hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                        className: "lg:hidden",
                        children: siteNav.map(function(link) {
                            var ref;
                            if ((link === null || link === void 0 ? void 0 : (ref = link.links) === null || ref === void 0 ? void 0 : ref.length) >= 1) {
                                return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                    className: "pb-4 mb-4 border-b-2 border-gray-100 last:border-none last:pb-0 last:mb-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "pt-1 pb-3 text-sm font-bold tracking-widest text-gray-700 uppercase",
                                            children: link.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            className: "grid md:grid-cols-2 gap-y-4 gap-x-8",
                                            children: link.links.map(function(link) {
                                                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: link.siteLink,
                                                    classes: "text-base font-medium text-gray-500 hover:text-gray-900",
                                                    children: link.title
                                                }, link._key);
                                            })
                                        })
                                    ]
                                }, link._key);
                            } else {
                                return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                    className: "pb-4 mb-4 border-b-2 border-gray-100 last:border-none last:pb-0 last:mb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: link.siteLink,
                                        classes: "mb-6 text-base font-medium text-gray-500 hover:text-gray-900",
                                        children: link.title
                                    })
                                }, link._key);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("nav", {
                        className: "w-full pt-4 mt-4 border-t-2 border-gray-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                                className: "grid mb-6 sm:grid-cols-2 gap-y-4 gap-x-8",
                                children: topNav && topNav.length >= 1 && (topNav === null || topNav === void 0 ? void 0 : topNav.map(function(link) {
                                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                            url: link === null || link === void 0 ? void 0 : link.siteLink,
                                            classes: "text-base font-medium text-gray-500 hover:text-gray-900 block",
                                            children: link.title
                                        })
                                    }, link._key);
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("ul", {
                                className: "grid grid-cols-2 mt-4 gap-y-4 gap-x-8",
                                children: [
                                    (process === null || process === void 0 ? void 0 : (ref = process.env) === null || ref === void 0 ? void 0 : "https://zssbnyqpmrpgsenpdyeb.supabase.co") && (process === null || process === void 0 ? void 0 : (ref1 = process.env) === null || ref1 === void 0 ? void 0 : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJvbGUiOiJhbm9uIiwiaWF0IjoxNjQyOTg2NTI5LCJleHAiOjE5NTg1NjI1Mjl9.m2Ijw3Q8jfMLguApk6apQpLW_D1LQiWb2bCFvy_wVyk") && appLoginEnabled === true && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                        children: [
                                            !isLoading && userDetails && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                        className: "col-span-2 sm:col-span-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                                                            href: "/app/dashboard",
                                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                                                className: "block w-full px-12 py-2 text-base font-medium text-center text-white bg-indigo-600 border border-transparent rounded-md shadow-sm whitespace-nowrap hover:bg-indigo-700",
                                                                children: "Dashboard"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                        className: "col-span-2 sm:col-span-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                            url: "/api/auth/logout",
                                                            classes: "block text-center px-12 py-2 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 w-full",
                                                            children: "Logout"
                                                        })
                                                    })
                                                ]
                                            }),
                                            !isLoading && !userDetails && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                        className: "col-span-2 sm:col-span-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                                                            href: "/app/login",
                                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                                                className: "block w-full px-12 py-2 text-base font-medium text-center text-white bg-indigo-600 border border-transparent rounded-md shadow-sm whitespace-nowrap hover:bg-indigo-700",
                                                                children: "Login"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                        className: "col-span-2 sm:col-span-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                            url: "/app/join",
                                                            classes: "block text-center px-12 py-2 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 w-full",
                                                            children: "Join"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (process === null || process === void 0 ? void 0 : (ref2 = process.env) === null || ref2 === void 0 ? void 0 : ref2.NEXT_PUBLIC_SNIPCART_PUB_API_KEY) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                        className: "flex items-center col-span-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                            className: "block w-full px-4 py-2 text-base font-medium text-center text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DynamicComponentWithNoSSR, {})
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/layout/header/index.js
/* provided dependency */ var header_process = __webpack_require__(83454);








var header_DynamicComponentWithNoSSR = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7265).then(__webpack_require__.bind(__webpack_require__, 27265));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27265)
            ];
        }
    },
    ssr: false
});
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function TopLevelLink(param) {
    var link = param.link;
    var ref;
    // console.log({link})
    if ((link === null || link === void 0 ? void 0 : (ref = link.links) === null || ref === void 0 ? void 0 : ref.length) >= 1) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(DropDown, {
            link: link
        }, link._key);
    } else {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                url: link.siteLink,
                classes: "text-base font-medium text-gray-500 hover:text-gray-900",
                children: link.title
            })
        }, link._key);
    }
}
function Header(param) {
    var siteNav = param.siteNav, topNav = param.topNav, siteSettings = param.siteSettings;
    var ref, ref1, ref2, ref3;
    var title = siteSettings.title;
    var appLoginEnabled = siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.appSettings) === null || ref === void 0 ? void 0 : ref.appLoginEnabled;
    var ref4 = (0,useUser/* useUser */.aF)(), isLoading = ref4.isLoading, subscription = ref4.subscription, userDetails = ref4.userDetails;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "mt-2 md:mt-4 inner-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("nav", {
                    className: "justify-end hidden w-full lg:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("ul", {
                        className: "flex space-x-4",
                        children: [
                            topNav && topNav.length >= 1 && (topNav === null || topNav === void 0 ? void 0 : topNav.map(function(link) {
                                /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                        url: link === null || link === void 0 ? void 0 : link.siteLink,
                                        classes: "text-sm font-medium text-gray-500 hover:text-gray-900",
                                        children: link.title
                                    })
                                }, link._key);
                            })),
                            (header_process === null || header_process === void 0 ? void 0 : (ref1 = header_process.env) === null || ref1 === void 0 ? void 0 : "https://zssbnyqpmrpgsenpdyeb.supabase.co") && (header_process === null || header_process === void 0 ? void 0 : (ref2 = header_process.env) === null || ref2 === void 0 ? void 0 : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJvbGUiOiJhbm9uIiwiaWF0IjoxNjQyOTg2NTI5LCJleHAiOjE5NTg1NjI1Mjl9.m2Ijw3Q8jfMLguApk6apQpLW_D1LQiWb2bCFvy_wVyk") && appLoginEnabled === true && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    !isLoading && userDetails && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                className: "".concat(topNav && topNav.length >= 1 && "pl-4 ml-2 border-l border-slate-200"),
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                                                    href: "/app/dashboard",
                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                                        className: "px-2 py-1 text-sm font-medium text-center text-white bg-indigo-600 border border-transparent rounded-md shadow-sm whitespace-nowrap hover:bg-indigo-700",
                                                        children: "Dashboard"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "/api/auth/logout",
                                                    classes: "text-center px-2 py-1 font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-sm",
                                                    children: "Logout"
                                                })
                                            })
                                        ]
                                    }),
                                    !isLoading && !userDetails && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                className: "".concat(topNav && topNav.length >= 1 && "pl-4 ml-2 border-l border-slate-200"),
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                                                    href: "/app/login",
                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                                        className: "px-2 py-1 text-sm font-medium text-center text-white bg-indigo-600 border border-transparent rounded-md shadow-sm whitespace-nowrap hover:bg-indigo-700",
                                                        children: "Login"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "/app/join",
                                                    classes: "text-center px-2 py-1 font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-sm",
                                                    children: "Join"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (header_process === null || header_process === void 0 ? void 0 : (ref3 = header_process.env) === null || ref3 === void 0 ? void 0 : ref3.NEXT_PUBLIC_SNIPCART_PUB_API_KEY) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                className: "flex items-center space-x-1 text-lg text-gray-600",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header_DynamicComponentWithNoSSR, {})
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "flex flex-wrap items-center justify-between mb-3 md:mb-4 lg:space-x-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "flex justify-start lg:w-0 lg:flex-1 ".concat(topNav && topNav.length >= 1 ? "lg:-mt-[27px]" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(linker/* Linker */.h, {
                                url: "/",
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                        className: "sr-only",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Logo, {
                                        classes: "w-auto h-12 md:h-16 lg:h-24",
                                        alt: "Logo",
                                        mode: "light"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("nav", {
                            className: "hidden lg:flex",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                                className: "flex space-x-10",
                                children: siteNav.map(function(link) {
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TopLevelLink, {
                                        link: link
                                    }, link._key);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MobileNav, {
                            siteNav: siteNav,
                            topNav: topNav,
                            appLoginEnabled: appLoginEnabled || false
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 93304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98107);



function SEO(param) {
    var site = param.site, page = param.page, path = param.path;
    var ref;
    // console.log({ site, page, path })
    var pagePath = (path === null || path === void 0 ? void 0 : path.replace(/^\/|\/$/g, "")) || "";
    var ref1 = page || null, pageSEO = ref1.seoSettings;
    var siteSEO = site.seoSettings;
    var siteURL = (site === null || site === void 0 ? void 0 : (ref = site.siteURL) === null || ref === void 0 ? void 0 : ref.replace(/^\/|\/$/g, "")) || "";
    var url = pagePath && siteURL && siteURL + "/" + pagePath;
    var title = (pageSEO === null || pageSEO === void 0 ? void 0 : pageSEO.title) || (siteSEO === null || siteSEO === void 0 ? void 0 : siteSEO.title);
    // console.log({url})
    var description = (pageSEO === null || pageSEO === void 0 ? void 0 : pageSEO.description) || (siteSEO === null || siteSEO === void 0 ? void 0 : siteSEO.description);
    var openGraphImage = (pageSEO === null || pageSEO === void 0 ? void 0 : pageSEO.openGraphImage) || (siteSEO === null || siteSEO === void 0 ? void 0 : siteSEO.openGraphImage);
    var ogImage = (openGraphImage === null || openGraphImage === void 0 ? void 0 : openGraphImage._type) === "image" && (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_2__/* .urlFor */ .uH)(openGraphImage).width(1200).url();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                httpEquiv: "x-ua-compatible",
                content: "ie=edge"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, shrink-to-fit=no"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("title", {
                children: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: description
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "twitter:creator",
                content: ""
            }),
            ogImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: ogImage
            }),
            ogImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "twitter:description",
                content: description
            }),
            ogImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "twitter:image",
                content: ogImage
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: url
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "canonical",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "apple-mobile-web-app-status-bar",
                content: "#1F2937"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "mask-icon",
                href: "/safari-pinned-tab.svg",
                color: "#f25f3f"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "msapplication-TileColor",
                content: "#1F2937"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                name: "theme-color",
                content: "#1F2937"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                rel: "preconnect",
                href: "https://cdn.sanity.io"
            })
        ]
    });
}


/***/ }),

/***/ 18668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);

function Loader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: "flex items-start justify-start mx-6 my-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "w-12 h-12 ease-linear border-4 border-t-4 border-gray-200 rounded-full loader"
        })
    });
}


/***/ }),

/***/ 71698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ PreviewAlert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16896);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5506);



function PreviewAlert(param) {
    var asPath = param.asPath;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: "bg-gray-800",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "py-2 inner-wrapper",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                className: "flex flex-wrap items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                        className: "flex items-center flex-1 w-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                className: "flex p-2 rounded-lg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    className: "w-4 h-4 text-white",
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                                className: "my-0 ml-3 text-sm font-medium text-white truncate",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                    className: "md:inline",
                                    children: "You are in Preview Mode."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: "w-auto mt-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("a", {
                            href: "/api/exit-preview?slug=".concat(asPath),
                            className: "inline-flex items-center px-2 py-1 text-sm font-medium leading-4 text-white bg-gray-800 border border-transparent rounded-md shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                            children: [
                                "Exit Preview",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    className: "ml-2 -mr-0.5 h-4 w-4",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "AW": function() { return /* binding */ camalize; },
/* harmony export */   "Gv": function() { return /* binding */ postDataNew; },
/* harmony export */   "Qr": function() { return /* binding */ isEmptyObject; },
/* harmony export */   "_r": function() { return /* binding */ TimeConvert; },
/* harmony export */   "dC": function() { return /* binding */ portableTextToPlainText; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "n8": function() { return /* binding */ transformToUpperCase; },
/* harmony export */   "nH": function() { return /* binding */ secondsToTime; },
/* harmony export */   "q0": function() { return /* binding */ toggle24hr; },
/* harmony export */   "qC": function() { return /* binding */ postData; },
/* harmony export */   "xb": function() { return /* binding */ isEmpty; }
/* harmony export */ });
/* unused harmony exports classNames, hasWhiteSpace, isObject, LabelFilter, isNumber, toCurrency, scaledImageURL, getURL, toDateTime */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98107);
/* provided dependency */ var process = __webpack_require__(83454);




// import { Price } from 'types'
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function hasWhiteSpace(s) {
    return s.indexOf(" ") >= 0;
}
function capitalizeFirstLetter(string) {
    var ref;
    return string ? ((ref = string[0]) === null || ref === void 0 ? void 0 : ref.toUpperCase()) + (string === null || string === void 0 ? void 0 : string.slice(1)) : null;
}
function transformToUpperCase(str, separators) {
    if (typeof str === "string" || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(str, String)) {
        separators = separators || [
            " "
        ];
        var regex = new RegExp("(^|[" + separators.join("") + "])(\\w)", "g");
        return "Hi" + str.toLowerCase().replace(regex, function(x) {
            return x.toUpperCase();
        }).replace("-", "");
    }
    return null;
}
function toggle24hr(time, onoff) {
    if (onoff == undefined) onoff = isNaN(time.replace(":", "")) //auto-detect format
    ;
    var pm = time.toString().toLowerCase().indexOf("pm") > -1 //check if 'pm' exists in the time string
    ;
    time = time.toString().toLowerCase().replace(/[ap]m/, "").split(":") //convert time to an array of numbers
    ;
    time[0] = Number(time[0]);
    if (onoff) {
        if (pm && time[0] != 12) time[0] += 12;
        else if (!pm && time[0] == 12) time[0] = "00" //handle midnight
        ;
        if (String(time[0]).length == 1) time[0] = "0" + time[0] //add leading zeros if needed
        ;
    } else {
        pm = time[0] >= 12;
        if (!time[0]) time[0] = 12 //handle midnight
        ;
        else if (pm && time[0] != 12) time[0] -= 12;
    }
    return onoff ? time.join(":") : time.join(":") + (pm ? "pm" : "am");
}
var truncate = function(input) {
    return (input === null || input === void 0 ? void 0 : input.length) > 300 ? "".concat(input.substring(0, 325), "...") : input;
};
function isObject(val) {
    if (val === null) {
        return false;
    }
    return typeof val === "function" || typeof val === "object";
}
function LabelFilter(val) {
    // Replaces '_' with a space and capitalizes the first lettter of each word
    return val.replace(/_/g, " ").split(" ").map(function(val) {
        return val[0].toUpperCase() + val.substring(1);
    }).join(" ");
}
function isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
}
function toCurrency(numberString) {
    if (!isNumber) {
        return null;
    } else {
        return new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "USD",
            currencyDisplay: "narrowSymbol"
        }).format(numberString);
    }
}
function portableTextToPlainText() {
    var blocks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return blocks// loop through each block
    .map(function(block) {
        // if it's not a text block with children,
        // return nothing
        if (block._type !== "block" || !block.children) {
            return "";
        }
        // loop through the children spans, and join the
        // text strings
        return block.children.map(function(child) {
            return child.text;
        }).join("");
    })// join the paragraphs leaving split by two linebreaks
    .join("\n\n");
}
var scaledImageURL = function(val, height, width) {
    return val ? "".concat(urlFor(val).auto("format").width(height || 800).height(width || 600).url()) : null;
};
function TimeConvert(n) {
    var dminutes = function dminutes(min) {
        if (min === 0) {
            return "";
        } else if (min === 1) {
            return min + " and minute ";
        } else {
            return min + " and minutes ";
        }
    };
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    var dhours = rhours > 1 ? rhours + " hours " : rhours + " hour ";
    // rminutes > 1 ? rminutes + " minutes " :
    return dhours + dminutes(rminutes);
}
function isEmpty(value) {
    return value == null || value === "" || value === undefined;
}
var getURL = function() {
    var ref, ref1, ref2, ref3;
    var url = (process === null || process === void 0 ? void 0 : (ref = process.env) === null || ref === void 0 ? void 0 : "https://www.redwolfreliability.com") && (process === null || process === void 0 ? void 0 : (ref1 = process.env) === null || ref1 === void 0 ? void 0 : "https://www.redwolfreliability.com") !== "" ? "https://www.redwolfreliability.com" : (process === null || process === void 0 ? void 0 : (ref2 = process.env) === null || ref2 === void 0 ? void 0 : ref2.VERCEL_URL) && (process === null || process === void 0 ? void 0 : (ref3 = process.env) === null || ref3 === void 0 ? void 0 : ref3.VERCEL_URL) !== "" ? process.env.VERCEL_URL : "http://localhost:3000";
    return url.includes("http") ? url : "https://".concat(url);
};
var postData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var url, data, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, data = param.data;
                    console.log("posting,", url, data);
                    return [
                        4,
                        fetch(url, {
                            method: "POST",
                            headers: new Headers({
                                "Content-Type": "application/json"
                            }),
                            credentials: "same-origin",
                            body: JSON.stringify(data)
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) {
                        console.log("Error in postData", {
                            url: url,
                            data: data,
                            res: res
                        });
                        console.log({
                            res: res
                        });
                        console.log({
                            data: data
                        });
                        throw Error(res.statusText);
                    }
                    return [
                        2,
                        res.json()
                    ];
            }
        });
    });
    return function postData(_) {
        return _ref.apply(this, arguments);
    };
}();
var postDataNew = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var url, data, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, data = param.data;
                    console.log("posting,", url, data);
                    return [
                        4,
                        fetch(url, {
                            method: "POST",
                            headers: new Headers({
                                "Content-Type": "application/json"
                            }),
                            credentials: "same-origin",
                            body: JSON.stringify(data)
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) {
                        console.log("Error in postData", {
                            url: url,
                            data: data,
                            res: res
                        });
                        console.log({
                            res: res
                        });
                        console.log({
                            data: data
                        });
                        throw Error(res.statusText);
                    }
                    return [
                        2,
                        res.json()
                    ];
            }
        });
    });
    return function postDataNew(_) {
        return _ref.apply(this, arguments);
    };
}();
var toDateTime = function(secs) {
    var t = new Date("1970-01-01T00:30:00Z"); // Unix epoch start.
    t.setSeconds(secs);
    return t;
};
var isEmptyObject = function(object) {
    for(var property in object){
        return false;
    }
    return true;
};
var secondsToTime = function(e) {
    var h = Math.floor(e / 3600).toString().padStart(2, "0"), m = Math.floor(e % 3600 / 60).toString().padStart(2, "0"), s = Math.floor(e % 60).toString().padStart(2, "0");
    return "".concat(h, ":").concat(m, ":").concat(s);
};
var camalize = function(str) {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function(m, chr) {
        return chr.toUpperCase();
    });
};



/***/ })

}]);